import React from "react";
import { ExcelDocumentIcon, ExcelLogoIcon } from "@fluentui/react-icons";
import * as XLSX from "xlsx";
import { TooltipHost } from "@fluentui/react";
import styles from './index.module.sass'
import moment from "moment";
import { decimalFormatter, longDecimalFormatter, setCurrency, setLongCurrency } from "../../utils/numberFormatter";

export interface Props
{
    headers: string[],
    getDataToExport: () => any[],
    name: string
}

export const ExportIndex: React.FunctionComponent<Props> = (props: Props) =>
{
    const date = (new Date(Date.now()).toLocaleDateString()).replaceAll("/", "-");

    const handleCSV = () =>
    {
        const data = props.getDataToExport();

        var csv: any = [];
        var csvFile, downloadLink;

        csv.push(props.headers.join(";"));

        for (var i = 0; i < data.length; i++)
        {
            csv.push(data[i].join(";"));

            const movements = data[i][data[i].length-1];
            if (Array.isArray(movements) &&  movements.length > 0) {
                csv.push(movements.map((movement: any) => {
                    const description = movement.cashIn ? movement.description : movement.title;

                    return [
                        'Operación',
                        moment(movement.operationAt).format('DD/MM/YYYY'),
                        moment(movement.settlementDate).format('DD/MM/YYYY'),
                        '',
                        data[7] !== 'Traspaso interno' || description.startsWith('Baja') ? `${movement.operationInstrument.isin} - ${movement.operationInstrument.name}` : '',
                        data[7] === 'Traspaso interno' && !description.startsWith('Baja') ? `${movement.operationInstrument.isin} - ${movement.operationInstrument.name}` : '',
                        description,
                        '',
                        setCurrency(movement.currency, movement.amount),
                        longDecimalFormatter.format(movement.titles),
                        setLongCurrency(movement.currency, movement.nav),
                        movement.exchangeRate === 1 ? movement.exchangeRate : decimalFormatter.format(movement.exchangeRate)
                    ];
                }).join(";"));
            }
        }

        csv = csv.join("\n");
        csvFile = new Blob(['\uFEFF' + csv], {type: "text/csv;charset=utf-8"});

        downloadLink = document.createElement("a");
        downloadLink.download = props.name+"-"+date+".csv";
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
    }

    const handleExcel = () =>
    {
        const data = props.getDataToExport();

        const wb = XLSX.utils.book_new();
        wb.Props =
        {
            Title: props.name + "-" + date + ".xlsx",
            CreatedDate : new Date()
        };
        wb.SheetNames.push(date);

        var allData: any[] = [props.headers];

        for (let i = 0; i < data.length; i++)
        {
            allData.push(data[i].slice(0, data[i].length-1));

            const movements = data[i][data[i].length-1];
            if (Array.isArray(movements) &&  movements.length > 0) {
                allData.push(...movements.map((movement: any) => {
                    const description = movement.cashIn ? movement.description : movement.title;

                    return [
                        'Operación',
                        moment(movement.operationAt).format('DD/MM/YYYY'),
                        moment(movement.settlementDate).format('DD/MM/YYYY'),
                        '',
                        !data[i][7].startsWith('Traspaso') || description.startsWith('Baja') ? `${movement.operationInstrument.isin} - ${movement.operationInstrument.name}` : '',
                        data[i][7].startsWith('Traspaso') && !description.startsWith('Baja') ? `${movement.operationInstrument.isin} - ${movement.operationInstrument.name}` : '',
                        description,
                        '',
                        setCurrency(movement.currency, movement.amount),
                        longDecimalFormatter.format(movement.titles),
                        setLongCurrency(movement.currency, movement.nav),
                        movement.exchangeRate === 1 ? movement.exchangeRate : decimalFormatter.format(movement.exchangeRate)
                    ]
                }));
            }
        }

        var ws = XLSX.utils.aoa_to_sheet(allData);
        wb.Sheets[date] = ws;
        XLSX.writeFile(wb, props.name + "-" + date + ".xlsx");
    }

    return(
        <>
            <TooltipHost
                content="Excel"
                id={`excel`}
                className={styles.tooltip}
            >
                <ExcelLogoIcon
                    className={styles.icon}
                    onClick={handleExcel}
                >
                    Excel
                </ExcelLogoIcon>
            </TooltipHost>
            <TooltipHost
                content="CSV"
                id={`csv`}
                className={styles.tooltip}
            >
                <ExcelDocumentIcon
                    className={styles.icon}
                    onClick={handleCSV}
                >
                    CSV
                </ExcelDocumentIcon>
            </TooltipHost>
        </>
    );
}